module.exports = __webpack_public_path__ + "img/rubihorn.e87c5b22.jpg";